import React from 'react';
import 'devextreme/dist/css/dx.light.css';
import AppRouter from './routes/router';
import { DevExtremeModalGlobalStyles } from './components/UserData/Users.styles';


const App: React.FC = () => {
  return (
    <><DevExtremeModalGlobalStyles /><AppRouter /></>
  );
}

export default App;